module.exports = __webpack_public_path__ + "img/slsf.3f0ead6.png";